import { render } from "./PasswordPage.vue?vue&type=template&id=107fa13a&scoped=true"
import script from "./PasswordPage.vue?vue&type=script&lang=js"
export * from "./PasswordPage.vue?vue&type=script&lang=js"

import "./PasswordPage.vue?vue&type=style&index=0&id=107fa13a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107fa13a"]])

export default __exports__